import { data } from '../../svg/Cable/data';
import { makeIcon } from '../makeIcon';

export const Cable = makeIcon(data, 'cable', 'Cable');

export default Cable;
